var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecureContact = function SvgSecureContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    d: "m31.129 268.916-9 4v6c0 5.5 3.8 10.7 9 12 5.2-1.3 9-6.5 9-12v-6Zm7 11c-.5 4.1-3.3 7.8-7 8.9-3.7-1.1-6.5-4.8-7-8.9v-5.7l7-3.1 7 3.1Z",
    style: {
      fill: "#0a1343"
    },
    transform: "translate(-19.129 -267.916)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.589 278.916h5.25l-1.733-1.743 1.41-1.41 4.153 4.153-4.153 4.153-1.41-1.41 1.733-1.743h-5.25Z",
    style: {
      fill: "#0a1343"
    },
    transform: "translate(-19.129 -267.916)"
  }));
};
export default SvgSecureContact;